import AthenaAPI from '@/APIs/AthenaAPI';
import {DecisionProcessingChoice} from '@/APIs/types';
import {getApprovalRating} from '@/Core/helpers/utils/ratingMapping';
import RootStore from '@/Core/mobx/RootStore';
import {ApplicationData} from '@agenium-ai/agenium-client-sdk/dist/models';

export async function createHubspotProsperDeal() {
    const {parameterStore} = RootStore.agentPortalStore;
    const data = await AthenaAPI.upsertProsperDeal('create', parameterStore.formid);

    if (!data?.success) {
        console.error('ERROR CREATING HUBSPOT DEAL -- CHECK ATHENA LOGS', data?.message);
    }
}

export async function updateHubspotProsperDealGetDecision() {
    const {parameterStore} = RootStore.agentPortalStore;
    const data = await AthenaAPI.upsertProsperDeal('submit', parameterStore.formid);

    if (!data?.success) {
        console.error('ERROR UPDATING HUBSPOT DEAL TO SUBMIT -- CHECK ATHENA LOGS', data?.message);
    }
}

export async function updateHubspotProsperDealDocusignComplete() {
    const {parameterStore} = RootStore.agentPortalStore;
    const data = await AthenaAPI.upsertProsperDeal('docusignComplete', parameterStore.formid);

    if (!data?.success) {
        console.error('ERROR UPDATING HUBSPOT DEAL TO DOCUSIGN COMPLETE -- CHECK ATHENA LOGS', data?.message);
    }
}

export async function updateHubspotProsperDealDecisionReferredToUW() {
    const {parameterStore} = RootStore.agentPortalStore;
    const data = await AthenaAPI.upsertProsperDeal('refer', parameterStore.formid);

    if (!data?.success) {
        console.error('ERROR UPDATING HUBSPOT DEAL TO REFER -- CHECK ATHENA LOGS', data?.message);
    }
}

export async function updateHubspotProsperDealDecisionApproved(applicationData: ApplicationData[]) {
    const {parameterStore} = RootStore.agentPortalStore;
    const approvalRating = getApprovalRating(applicationData, parameterStore);

    const request = approvalRating
        ? {
              properties: {
                  approved_rating: approvalRating as any,
              },
          }
        : undefined;

    const data = await AthenaAPI.upsertProsperDeal('approve', parameterStore.formid, request ?? undefined);

    if (!data?.success) {
        console.error('ERROR UPDATING HUBSPOT DEAL TO APPROVE -- CHECK ATHENA LOGS', data?.message);
    }
}

export async function updateHubspotUpdatedQuoteValues({paidTargetAnnualPremium}: {paidTargetAnnualPremium: string}) {
    const {parameterStore} = RootStore.agentPortalStore;
    const data = await AthenaAPI.upsertProsperDeal('update', parameterStore.formid, {
        properties: {
            paid_target_annual_premium: paidTargetAnnualPremium,
        },
    });

    if (!data?.success) {
        console.error('ERROR UPDATING HUBSPOT DEAL WITH QUOTE VALUES -- CHECK ATHENA LOGS', data?.message);
    }
}

export async function updateHubspotProsperDealPolicyNumber(policyNumber: string) {
    const {parameterStore} = RootStore.agentPortalStore;
    const data = await AthenaAPI.upsertProsperDeal('update', parameterStore.formid, {
        properties: {
            policy_number: policyNumber,
        },
    });

    if (!data?.success) {
        console.error('ERROR UPDATING HUBSPOT DEAL TO WITH POLICY NUMBER -- CHECK ATHENA LOGS', data?.message);
    }
}

export async function updateHubspotProsperDealDecisionProcessingChoice(choice: DecisionProcessingChoice) {
    const {parameterStore} = RootStore.agentPortalStore;
    await AthenaAPI.upsertProsperDeal('update', parameterStore.formid, {
        properties: {
            decision_processing_choice: choice,
        },
    });
}

export async function updateHubspotProsperDealConditionalCoverage(conditionalCoverage: 'Yes' | 'No') {
    const {parameterStore} = RootStore.agentPortalStore;
    await AthenaAPI.upsertProsperDeal('update', parameterStore.formid, {
        properties: {
            conditional_coverage: conditionalCoverage,
        },
    });
}

export async function updateHubspotProsperDealBankingInfoProvidedUpfront(bankingInfoProvidedUpfront: 'Yes' | 'No') {
    const {parameterStore} = RootStore.agentPortalStore;
    await AthenaAPI.upsertProsperDeal('update', parameterStore.formid, {
        properties: {
            prosper_banking_info_provided_upfront: bankingInfoProvidedUpfront,
        },
    });
}
